import { useState } from "react";
import Drawer from "../drawer/Drawer.jsx";
import CustomButton from "../kits/custom-button/CustomButton";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import colorSchema from "../../assets/kits/colors";

export default function FailPaymentDrawer({ isOpen, setIsOpen, AddOrder }) {
  return (
    <Drawer
      height={156}
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <div className="mr-t-16 mr-x-20">
        <p
          className="desc-c-l"
          style={{
            color: colorSchema.foreground_background_he,
            height: 42,
            fontSize: 15,
          }}
        >
          پرداخت شما انجام نشد. آیا می‌خواهید دوباره امتحان کنید؟
        </p>
        <div className="d-flex w-100 mr-t-20">
          <CustomButton
            buttonStyle="primary"
            style={{ height: 48, width: "100%" }}
            onClick={() => AddOrder()}
          >
            تلاش دوباره
          </CustomButton>
          <CustomButton
            buttonStyle="text"
            style={{ width: "100%", height: 48 }}
            onClick={() => {
              setIsOpen(false);
            }}
          >
            انصراف
          </CustomButton>
        </div>
      </div>
    </Drawer>
  );
}
